import { FC, PropsWithChildren } from 'react';

import { GlobalStyles } from '@mui/material';

const globalStyles = {
  body: {
    margin: 0,
    fontFamily: 'Inter, sans-serif',
    backgroundColor: '#1a1e27',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  '#root': {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export const AuthGlobalStyles: FC<PropsWithChildren> = ({ children }) => (
  <>
    <GlobalStyles styles={globalStyles} />
    {children}
  </>
);
